import { render, staticRenderFns } from "./van-popup-stockInfo.vue?vue&type=template&id=1ff3b213&scoped=true"
import script from "./van-popup-stockInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./van-popup-stockInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./van-popup-stockInfo.vue?vue&type=style&index=0&id=1ff3b213&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff3b213",
  null
  
)

export default component.exports